import { boolean } from "boolean";

export default defineNuxtPlugin(async () => {
  if (inDevelopment.value) {
    const { setupWorker: setupBrowserServer } = await import("msw/browser");
    const { getMockAPIHandlers } = await import("~/utils/mock_server");
    const mockServer = setupBrowserServer(...getMockAPIHandlers());
    mockServer.start({
      onUnhandledRequest: "bypass",
      quiet: true,
    });
    mockServer.events.on("response:mocked", ({ request }) => {
      console.log("MSW response mocked:", request.url);
    });
  }
});
